

export default {
name: 'myStore',
components: {

},
data () {
return {
active: 'storeInfo',
showBottomNav: false,
}
},
methods: {
getStoreInfo () {
this.$request.post('/shop/getUserShopByUserId',{

}).then(data => {
if(data.code == 0){
if(data.obj != null && data.obj.doneStatus == '1' && data.obj.auditStatus == '1'){  //是店主
this.showBottomNav = true
if(this.$route.name == 'productUpload'){
this.showBottomNav = false
}
}else{
this.showBottomNav = false
this.$router.push({
path: '/myStore'
})
}
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
storeInfo () {
this.active = 'storeInfo'
this.$router.push({
path: '/myStore'
})
},
productList () {
this.active = 'productList'
this.$router.push({
path: '/myStore/productList'
})
},
sellOrders () {
this.active = 'sellOrders'
this.$router.push({
path: '/myStore/sellOrders'
})
},
productUpload () {
this.active = 'productUpload'
this.$router.push({
path: '/myStore/productUpload'
})
},
},
computed: {

},
mounted() {
this.active = this.$route.name;
},
watch: {
$route(to, from) {
this.active = to.name
if(to.name == 'productUpload'){
this.showBottomNav = false
}else{
this.showBottomNav = true
}
}
},
created () {
this.getStoreInfo()
}
}



// WEBPACK FOOTER //
// ./src/views/myStore/script.js